import request from '@/router/axios'

export const getList = (params) => request({
  url: '/api/produce/env-monitor/point/selectPage',
  method: 'post',
  data: params
})

export const getDetail = (id) => request({
  url: '/api/produce/env-monitor/point/selectId',
  method: 'get',
  params: { id }
})

export const add = (data) => request({
  url: '/api/produce/env-monitor/point/insert',
  method: 'post',
  data
})

export const update = (data) => request({
  url: '/api/produce/env-monitor/point/update',
  method: 'post',
  data
})

export const remove = (id) => request({
  url: '/api/produce/env-monitor/point/deleteId',
  method: 'get',
  params: { id }
})

export const pull = () => request({
  url: '/api/produce/env-monitor/pull/execute',
  method: 'post'
})

export const getHistory = (params) => request({
  url: '/api/produce/env-monitor/point-value/selectPage',
  method: 'post',
  data: params
})
